(() => {
  const moneyFormat = window.Shopify?.currency?.active || "GBP";

  function announce(message) {
    const region = document.querySelector("[data-live-region]");
    if (region) region.textContent = message;
  }

  function formatMoney(cents) {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || "en", {
        style: "currency",
        currency: moneyFormat
      }).format(cents / 100);
    } catch {
      return `£${(cents / 100).toFixed(2)}`;
    }
  }

  function openCart() {
    closeSearch();
    document.body.classList.remove("menu-open");
    document.body.classList.add("cart-open");
    document.querySelector(".cart-drawer")?.setAttribute("aria-hidden", "false");
  }

  function closeCart() {
    document.body.classList.remove("cart-open");
    document.querySelector(".cart-drawer")?.setAttribute("aria-hidden", "true");
  }

  function openSearch() {
    closeCart();
    document.body.classList.remove("menu-open");
    document.body.classList.add("search-open");
    const modal = document.querySelector(".search-modal");
    modal?.setAttribute("aria-hidden", "false");
    window.setTimeout(() => document.querySelector("[data-search-input]")?.focus(), 80);
  }

  function closeSearch() {
    document.body.classList.remove("search-open");
    document.querySelector(".search-modal")?.setAttribute("aria-hidden", "true");
  }

  async function fetchCart() {
    const response = await fetch("/cart.js", {
      headers: { Accept: "application/json" }
    });
    if (!response.ok) throw new Error("Unable to load cart.");
    return response.json();
  }

  async function renderCart() {
    const root = document.querySelector("[data-cart-items]");
    const subtotal = document.querySelector("[data-cart-subtotal]");
    const counts = document.querySelectorAll("[data-cart-count]");
    if (!root || !subtotal) return;

    const cart = await fetchCart();
    counts.forEach((count) => {
      count.textContent = String(cart.item_count);
    });
    subtotal.textContent = formatMoney(cart.total_price);

    if (!cart.items.length) {
      root.innerHTML = '<div class="cart-empty"><p>Your cart is empty.</p></div>';
      return;
    }

    root.innerHTML = cart.items.map((item) => {
      const image = item.image ? `<img src="${item.image}" alt="${item.product_title}" loading="lazy" decoding="async" width="76" height="76">` : "";
      return `
        <article class="cart-item">
          ${image}
          <div>
            <h3>${item.product_title}</h3>
            <p>${formatMoney(item.final_line_price)}</p>
            <div class="cart-item__controls">
              <span class="cart-qty">
                <button type="button" data-cart-step="-1" data-cart-key="${item.key}" aria-label="Decrease ${item.product_title} quantity">-</button>
                <span>${item.quantity}</span>
                <button type="button" data-cart-step="1" data-cart-key="${item.key}" aria-label="Increase ${item.product_title} quantity">+</button>
              </span>
              <button class="cart-remove" type="button" data-cart-remove="${item.key}">Remove</button>
            </div>
          </div>
        </article>
      `;
    }).join("");
  }

  async function addFormToCart(form) {
    const response = await fetch("/cart/add.js", {
      method: "POST",
      body: new FormData(form),
      headers: { Accept: "application/json" }
    });

    if (!response.ok) {
      announce("This item could not be added to cart.");
      return;
    }

    await renderCart();
    openCart();
    announce("Item added to cart.");
  }

  async function changeCartItem(key, quantity) {
    const response = await fetch("/cart/change.js", {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ id: key, quantity })
    });

    if (response.ok) {
      await renderCart();
    }
  }

  function currentQuantity(button) {
    const row = button.closest(".cart-item");
    const text = row?.querySelector(".cart-qty span")?.textContent || "0";
    return Number.parseInt(text, 10) || 0;
  }

  function pageQuantity() {
    const input = document.querySelector("[data-quantity-input]");
    const value = Number.parseInt(input?.value || "1", 10);
    return Number.isFinite(value) && value > 0 ? value : 1;
  }

  function setPageQuantity(value) {
    const input = document.querySelector("[data-quantity-input]");
    if (input) input.value = String(Math.max(1, value));
  }

  function bindEvents() {
    document.addEventListener("click", async (event) => {
      const menuToggle = event.target.closest("[data-menu-toggle]");
      if (menuToggle) {
        const open = document.body.classList.toggle("menu-open");
        menuToggle.setAttribute("aria-expanded", String(open));
        closeCart();
        closeSearch();
        return;
      }

      if (event.target.closest("[data-search-open]")) {
        openSearch();
        return;
      }

      if (event.target.closest("[data-search-close]")) {
        closeSearch();
        return;
      }

      if (event.target.closest("[data-cart-open]")) {
        await renderCart();
        openCart();
        return;
      }

      if (event.target.closest("[data-cart-close]")) {
        closeCart();
        return;
      }

      const cartStep = event.target.closest("[data-cart-step]");
      if (cartStep) {
        const next = Math.max(0, currentQuantity(cartStep) + Number.parseInt(cartStep.dataset.cartStep, 10));
        await changeCartItem(cartStep.dataset.cartKey, next);
        return;
      }

      const remove = event.target.closest("[data-cart-remove]");
      if (remove) {
        await changeCartItem(remove.dataset.cartRemove, 0);
        return;
      }

      const faqToggle = event.target.closest("[data-faq-toggle]");
      if (faqToggle) {
        const item = faqToggle.closest(".faq__item");
        const open = item.classList.toggle("is-open");
        faqToggle.setAttribute("aria-expanded", String(open));
        return;
      }

      const quantityStep = event.target.closest("[data-quantity-step]");
      if (quantityStep) {
        setPageQuantity(pageQuantity() + Number.parseInt(quantityStep.dataset.quantityStep, 10));
        return;
      }

      const galleryButton = event.target.closest("[data-gallery-image]");
      if (galleryButton) {
        const main = document.querySelector("[data-gallery-main]");
        if (main) {
          main.src = galleryButton.dataset.galleryImage;
          main.removeAttribute("srcset");
        }
        document.querySelectorAll(".gallery-thumb").forEach((button) => button.classList.remove("is-active"));
        galleryButton.classList.add("is-active");
        return;
      }

      if (event.target.closest("[data-mobile-product-submit]")) {
        document.querySelector(".mdora-product-form [name='add']")?.click();
      }
    });

    document.addEventListener("submit", async (event) => {
      const form = event.target.closest(".mdora-product-card-form, .mdora-product-form");
      if (!form) return;
      event.preventDefault();
      await addFormToCart(form);
    });

    document.addEventListener("input", (event) => {
      if (event.target.matches("[data-quantity-input]")) {
        setPageQuantity(pageQuantity());
      }
    });

    document.addEventListener("keydown", (event) => {
      if (event.key === "Escape") {
        document.body.classList.remove("menu-open");
        closeCart();
        closeSearch();
      }
    });
  }

  document.addEventListener("DOMContentLoaded", () => {
    bindEvents();
    renderCart().catch(() => {});
  });
})();
